import { FormGroup, Icon } from '@talos/kyoko';
import styled from 'styled-components';

export const TransferFormWrapper = styled.form`
  background: ${({ theme }) => theme.backgroundContent};
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  padding: ${({ theme }) => theme.spacing16}px;
`;

export const Content = styled.div`
  flex: 1 1 0;
  padding: ${({ theme }) => theme.spacing32}px;
  max-width: 500px;
  margin: 0 auto;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${({ theme }) => theme.spacing16}px;

  gap: ${({ theme }) => theme.spacing16}px;

  ${FormGroup} {
    flex: 1;
    margin-bottom: ${({ theme }) => theme.baseSize * theme.fontSizeFormHelp + theme.spacing8}px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing24}px;
`;

export const InfoWrapper = styled(Row)`
  p {
    margin-top: ${({ theme }) => theme.spacing2}px;
    margin-left: ${({ theme }) => theme.spacing4}px;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DialogWrapper = styled.div`
  h3 {
    margin: 0;
    margin-bottom: ${({ theme }) => theme.spacing8}px;
  }
`;

export const CenteredRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing2}px;
  ${Icon} {
    margin: 0 ${({ theme }) => theme.spacing4}px;
  }
`;
